// extracted by mini-css-extract-plugin
export default {"controlVolumeCont":"control-brightness_controlVolumeCont__0eCxo","header":"control-brightness_header__1MdMU"};